import { render, staticRenderFns } from "./HandbookBuilderScreens.vue?vue&type=template&id=2c45f153&scoped=true&"
import script from "./HandbookBuilderScreens.vue?vue&type=script&lang=js&"
export * from "./HandbookBuilderScreens.vue?vue&type=script&lang=js&"
import style0 from "./HandbookBuilderScreens.vue?vue&type=style&index=0&id=2c45f153&scoped=true&lang=css&"
import style1 from "./HandbookBuilderScreens.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c45f153",
  null
  
)

export default component.exports